module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b2c44c738c9cbc1a99cd6edfd0c2b85b.svg";